import {Component, Input} from "@angular/core";
import {EditableListItem} from "../graphql/common.gql-model";
import {FilteredList} from "../helpers/filtered-list";

@Component({
  selector: "list-edit-controls",
  templateUrl: "./list-edit-controls.template.pug",
})
export class ListEditControlsComponent {
  @Input()
  item: EditableListItem;

  @Input()
  list: FilteredList<EditableListItem>;

  edit() {
    this.item.editing = true;
  }

  save() {
    this.item.editing = false;
    this.list.refreshDisplay();
  }

  remove() {
    this.list.remove(this.item);
  }
}
